import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [
    NgOptimizedImage,
    RouterLink,
    TranslatePipe
  ],
  templateUrl: './footer.html',
  styles: ``
})
export class Footer {
}
